/*requires SearchControl.js*/
//
// KeywordCriteria javascript
//
// Ben Ramey
// August 2011
//
HEIJS.registerNamespace("HEIJS.SearchControl");
HEIJS.SearchControl.KeywordCriteria = function (parentElement)
{
  this.textbox = $("input.keywordcriteria-textbox", parentElement);

  if (this.textbox.length == 0)
    return;

  this.typeDDL = this.textbox.siblings("select");

  this.init();
};

HEIJS.SearchControl.KeywordCriteria.prototype =
{
  //
  // properties
  //
  textbox: null,
  typeDDL: null,

  //
  // methods
  //
  // todo: limit the highlighting to only the columns
  // that the keyword criteria is actually attached to.
  init: function ()
  {
    var keywords = this.textbox.val();
    if (keywords === "")
      return;

    if (this.typeDDL.val() != "ExactPhrase")
    {
      keywords = keywords.split(" ");
    }
    else
    {
      keywords = [keywords];
    }

    var cells = $("tr.dxgvDataRow td:visible");
    if (cells.length == 0) // no search results in grid
      return;

    keywords = keywords.join("|");
    var regex = new RegExp("(" + keywords + ")", "gi");
    cells.textNodes().replaceWith(function ()
    {
      var text = $(this).text();
      if (regex.test(text))
      {
        return text.replace(regex, "<span class='keywordcriteria-highlight'>$1</span>");
      }

      return text;
    });

    for (var idx = 0; idx < keywords.length; idx++)
    {
    }
  }
};